function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { withTheme } from '../../core/theming';
import Text, { TextType } from '../Typography/Text';
export let ButtonType;

(function (ButtonType) {
  ButtonType["Primary"] = "primary";
  ButtonType["Secondary"] = "secondary";
  ButtonType["Transparent"] = "transparent";
  ButtonType["Warning"] = "warning";
})(ButtonType || (ButtonType = {}));

function getButtonProps(_ref) {
  let {
    type,
    disabled,
    theme: {
      colors: {
        button: themeButton,
        text: themeText
      }
    }
  } = _ref;
  let props;

  switch (type) {
    case ButtonType.Primary:
      {
        props = {
          textType: TextType.ButtonPrimary,
          colors: {
            background: themeButton.primary,
            text: themeText.ondark,
            border: themeButton.primary
          }
        };
        break;
      }

    case ButtonType.Secondary:
      {
        props = {
          textType: TextType.ButtonPrimary,
          colors: {
            background: themeButton.secondary,
            text: themeText.buttonSecondary,
            border: themeButton.secondaryBorder
          }
        };
        break;
      }

    case ButtonType.Transparent:
      {
        props = {
          textType: TextType.ButtonPrimary,
          colors: {
            background: 'transaprent',
            text: themeText.ondark,
            border: themeButton.transparentBorder
          }
        };
        break;
      }

    case ButtonType.Warning:
      {
        props = {
          textType: TextType.ButtonPrimary,
          colors: {
            background: themeButton.negative,
            text: themeText.ondark,
            border: themeButton.negative
          }
        };
        break;
      }

    default:
      {
        props = {
          textType: TextType.ButtonPrimary,
          colors: {
            background: themeButton.primary,
            text: themeText.ondark,
            border: themeButton.primary
          }
        };
      }
  }

  if (disabled) {
    props.colors = {
      background: themeButton.disabled,
      text: themeText.disabled,
      border: themeButton.disabled
    };
  }

  return props;
}

const buttonAccessibilityState = isDisabled => {
  const accessbilityState = {
    accessibilityState: {
      disabled: isDisabled
    }
  };
  return accessbilityState;
};

const Button = _ref2 => {
  let {
    disabled = false,
    type = ButtonType.Primary,
    style,
    textType,
    textStyle,
    children,
    icon,
    theme,
    ...props
  } = _ref2;
  const [radius, setRadius] = useState(styles.container.borderRadius);
  const {
    colors,
    textType: defaultTextType
  } = getButtonProps({
    type,
    disabled,
    theme
  });
  const containerStyle = {
    backgroundColor: colors.background,
    borderColor: colors.border,
    borderRadius: radius
  }; // Called if button becomes multiline to re-calculate readiues

  const onLayout = _ref3 => {
    var _nativeEvent$layout;

    let {
      nativeEvent
    } = _ref3;
    setRadius((nativeEvent === null || nativeEvent === void 0 ? void 0 : (_nativeEvent$layout = nativeEvent.layout) === null || _nativeEvent$layout === void 0 ? void 0 : _nativeEvent$layout.height) || 0 / 2);
  };

  return /*#__PURE__*/React.createElement(TouchableOpacity, _extends({}, props, {
    style: [styles.container, icon ? {
      paddingVertical: 0
    } : null, containerStyle, style],
    activeOpacity: 0.5,
    accessibilityRole: 'button'
  }, buttonAccessibilityState(disabled), {
    disabled: disabled,
    onLayout: onLayout
  }), icon ? /*#__PURE__*/React.cloneElement(icon, {
    color: colors.text
  }) : /*#__PURE__*/React.createElement(Text, {
    style: [styles.text, textStyle],
    type: textType || defaultTextType,
    color: colors.text,
    numberOfLines: 2
  }, children));
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 40,
    minWidth: 80,
    borderWidth: 1.5,
    borderRadius: 16,
    paddingVertical: 9
  },
  text: {
    textAlign: 'center',
    paddingHorizontal: 13,
    width: '100%'
  }
});
export default withTheme(Button);
//# sourceMappingURL=index.js.map